/**
 * V9 blocks the design draws that no back-end route serves yet. Each is a typed placeholder:
 * the page renders its honest empty state from it and never shows an invented figure as
 * real. When the route lands, the loader here is the one place to swap.
 *
 * Back-end gaps (also in the V9 port report):
 *  - Team memo: POST /overview/memos { to, text } and GET /overview/memos (sent, who read
 *    it); Care Staff read theirs on the Worklist and tap Got it.
 *  - Family check-ins: GET /overview/family-checkins?days=7 (answered, by answer, the
 *    trend, the low answers with a call-back deadline) and POST .../:id/called-back.
 */

/** A memo the Facility Admin sent to staff (design memoVals, L40014). */
export interface TeamMemo {
  id: string;
  to: 'All staff' | 'Nurses' | 'Aides' | 'Night shift';
  text: string;
  sentAt: string;
  by: string;
  read: number;
  of: number;
}

export interface TeamMemoFeed {
  /** False until the memo service exists: the card shows its empty state. */
  connected: boolean;
  memos: TeamMemo[];
}

/** One low answer that needs a call back (design fcRows, L51027). */
export interface FamilyCheckinRow {
  id: string;
  /** "Linda, daughter of Inez · Room 211 · “Not good”" */
  who: string;
  said: string;
  callBackBy: string | null;
  calledBack: boolean;
}

export interface FamilyCheckins {
  connected: boolean;
  answered: number | null;
  families: number | null;
  /** "Very good or good: 74% this week, up from 68% four weeks ago." */
  trend: string | null;
  rows: FamilyCheckinRow[];
}

export const TEAM_MEMO_NOT_CONNECTED: TeamMemoFeed = { connected: false, memos: [] };
export const FAMILY_CHECKINS_NOT_CONNECTED: FamilyCheckins = { connected: false, answered: null, families: null, trend: null, rows: [] };

/** Until GET /overview/memos exists. */
export function teamMemoFeed(): TeamMemoFeed {
  return TEAM_MEMO_NOT_CONNECTED;
}

/** Until GET /overview/family-checkins exists. */
export function familyCheckins(): FamilyCheckins {
  return FAMILY_CHECKINS_NOT_CONNECTED;
}
